import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { backOfficeInstance } from 'libraries/axios';
import GoBack from '../general/go_back';
import { useEffect } from 'react';

export default function Register() {
  const { t } = useTranslation('translations', { useSuspense: false });
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const [repeatPassword, setRepeatPassword] = useState('');
  const [selectedDate, setSelectedDate] = useState();
  const [succesfull, setSuccesfull] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const onSubmit = (data) => {
    if (data.password !== repeatPassword) {
      const newLocal = t('passwordmismatch');
    } else {
      const request = backOfficeInstance.post(`/Customer/CreateOnlineCustomer`, data);
      request
        .then((response) => {
          setSuccesfull(true);
        })
        .catch((error) => {
          const resMessage =
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString();
          setSuccesfull(false);
        });
      navigate('/login');
    }
  };
  return (
    <Container>
      <Row>
        <Col xs={1}>
          <div className="mt5"></div>
          <GoBack />
        </Col>
        <Col xs={5}>
          <div className="float-left mt-3 fweight-bold fsize-14"> {t('registration')}</div>
        </Col>
      </Row>
      <div className="mt15"></div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col>
            <Form.Group controlId="formBasicUsername">
              <Form.Label
                htmlFor="username"
                className="profile-text font-size-12 mt-2">
                {t('username')}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={t('username')}
                {...register('username', { required: true })}
              />
            </Form.Group>
            {errors.username && <p>{t('pleasecheckusername')}</p>}
          </Col>

          <Col>
            <Form.Group controlId="formBasicPassword">
              <Form.Label
                htmlFor="password"
                className="profile-text font-size-12 mt-2">
                {t('password')}
              </Form.Label>
              <Form.Control type="password" placeholder={t('password')} {...register('password')} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Row>
            <Col>
              <Form.Group controlId="formBasicRepeatPassword">
                <Form.Label
                  htmlFor="repeatpassword"
                  className="profile-text font-size-12 mt-2">
                  {t('repeatpassword')}
                </Form.Label>
                <Form.Control
                  type="password"
                  placeholder={t('repeatpassword')}
                  onChange={(event) => setRepeatPassword(event.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="doj">
                <Form.Label className="profile-text font-size-12 mt-2">
                  {t('dateofbirth')}
                </Form.Label>
                <Form.Control
                  type="date"
                  name="doj"
                  placeholder={t('dateofbirth')}
                  onChange={handleDateChange}
                  {...register('birthday')}
                />
              </Form.Group>
            </Col>
          </Row>
        </Row>
        <Row>
          <Col>
            <Form.Group controlId="formBasicFirstname">
              <Form.Label
                htmlFor="firstname"
                className="profile-text font-size-12 mt-2">
                {t('firstname')}
              </Form.Label>
              <Form.Control
                className="w-1/2"
                type="text"
                placeholder={t('firstname')}
                {...register('name')}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formBasicLastname">
              <Form.Label
                htmlFor="lastname"
                className="profile-text font-size-12 mt-2">
                {t('lastname')}
              </Form.Label>
              <Form.Control
                className="w-1/2"
                type="text"
                placeholder={t('lastname')}
                {...register('surname')}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Group controlId="formBasicPhoneNumber">
              <Form.Label
                htmlFor="phonenumber"
                className="profile-text font-size-12 mt-2">
                {t('phonenumber')}
              </Form.Label>
              <Form.Control type="text" placeholder={t('phonenumber')} {...register('telephone')} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formBasicEmail">
              <Form.Label htmlFor="email" className="profile-text font-size-12 mt-2">
                {t('email')}
              </Form.Label>
              <Form.Control
                type="email"
                placeholder={t('email')}
                {...register('email', {
                  required: true,
                  pattern:
                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                })}
              />
            </Form.Group>
            {errors.email && <p>{t('pleasecheckemail')}</p>}
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Group controlId="formBasicGender">
              <Form.Label htmlFor="gender" className="profile-text font-size-12 mt-2">
                {t('gender')}
              </Form.Label>
              <Form.Control type="text" placeholder={t('gender')} {...register('gender')} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formBasicTitle">
              <Form.Label htmlFor="title" className="profile-text font-size-12 mt-2">
                {t('title')}
              </Form.Label>
              <Form.Control type="text" placeholder={t('title')} {...register('title')} />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Group controlId="formBasicRepeatProfession">
              <Form.Label
                htmlFor="profession"
                className="profile-text font-size-12 mt-2">
                {t('profession')}
              </Form.Label>
              <Form.Control type="text" placeholder={t('profession')} {...register('profession')} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formBasicPassportNumber">
              <Form.Label
                htmlFor="passportnumber"
                className="profile-text font-size-12 mt-2">
                {t('passportnumber')}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={t('passportnumber')}
                {...register('passportNumber')}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Group controlId="formBasicStreet">
              <Form.Label htmlFor="street" className="profile-text font-size-12 mt-2">
                {t('street')}
              </Form.Label>
              <Form.Control type="text" placeholder={t('street')} {...register('street')} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formBasicZip">
              <Form.Label htmlFor="zip" className="profile-text font-size-12 mt-2">
                {t('zip')}
              </Form.Label>
              <Form.Control type="text" placeholder={t('zip')} {...register('zip')} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group controlId="formBasicCity">
              <Form.Label htmlFor="city" className="profile-text font-size-12 mt-2">
                {t('city')}
              </Form.Label>
              <Form.Control type="text" placeholder={t('city')} {...register('city')} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formBasicNationality">
              <Form.Label
                htmlFor="nationality"
                className="profile-text font-size-12 mt-2">
                {t('nationality')}
              </Form.Label>
              <Form.Control type="text" placeholder={t('nationality')} {...register('nationality')} />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Group controlId="formBasicBankDetails">
              <Form.Label
                htmlFor="bankdetails"
                className="profile-text font-size-12 mt-2">
                {t('bankdetails')}
              </Form.Label>
              <Form.Control type="text" placeholder={t('bankdetails')} {...register('bankDetails')} />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="formBasicBalance">
              <Form.Label htmlFor="balance" className="profile-text font-size-12 mt-2">
                {t('balance')}
              </Form.Label>
              <Form.Control type="text" placeholder={t('balance')} {...register('balance')} />
            </Form.Group>
          </Col>
        </Row>

        <div className="mt10"></div>
        <Button
          variant="contained"
          type="submit"
          block
          size="lg"
          style={{
            backgroundColor: '#3AA843',
            color: '#FFFFFF'
          }}>
          {t('register')}
        </Button>
      </Form>
      <div className="mt10"></div>
      <Row>
        <Col xs={11}>
          <span className="fsize-10">
            {t('alreadyhaveaccount')}{' '}
            <Link to={'/login'} className="fweight-bold">
              | {t('here')}{' '}
            </Link>
          </span>
        </Col>
      </Row>
    </Container>
  );
}
